const FIORI_GOVERNED = 'Fiori Governed';
const MOC_GOVERNED = 'MoC Governed';
const INTERNAL_GOVERNED = 'SW Governed';
const APM_GOVERNED = 'APM Governed';

const draftStatus = 'Draft';
const awaitingReviewStatus = 'Awaiting review';
const declineReviewStatus = 'Review declined';
const awaitingControlStatus = 'Awaiting control owner approval';
const declineControlStatus = 'Control owner approval declined';
const awaitingStratStatus = 'Awaiting strategy approval';
const declineStratStatus = 'Strategy approval declined';
const awaitRiskStatus = 'Awaiting activity approval';
const declineRiskStatus = 'Activity approval declined';

//Governance Checks
export function isFioriGoverned(approvalInfo) {
  return approvalInfo.governanceType == FIORI_GOVERNED;
}

export function isMoCGoverned(approvalInfo) {
  return approvalInfo.governanceType == MOC_GOVERNED;
}

export function isSWGoverned(approvalInfo) {
  return approvalInfo.governanceType == INTERNAL_GOVERNED;
}

//Template State Checks (read only, draft)
export function isEditableTemplate(approvalInfo) {
  var status = approvalInfo.templateStatus;
  return (
    status == draftStatus ||
    status == declineReviewStatus ||
    status == declineControlStatus ||
    status == declineStratStatus ||
    status == declineRiskStatus
  );
}

export function isReviewTemplate(approvalInfo) {
  return approvalInfo.templateStatus == awaitingReviewStatus;
}

export function isControlTemplate(approvalInfo) {
  return approvalInfo.templateStatus == awaitingControlStatus;
}

export function isStrategyTemplate(approvalInfo) {
  return approvalInfo.templateStatus == awaitingStratStatus;
}

export function isRiskTemplate(approvalInfo) {
  return approvalInfo.templateStatus == awaitRiskStatus;
}

export function canRaiseRequest(
  approvalInfo,
  fioriComplete,
  isRequestNumberValid = true
) {
  // Can the user approve the activity version based on the incoming templating.
  if (approvalInfo.canApprove) {
    // IFF the activity version is fiori governed and all the fiori numbers are completed
    if (isFioriGoverned(approvalInfo)) {
      if (fioriComplete && isRequestNumberValid) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  return false;
}

export function isStrategyChange(elementChange) {
  return elementChange.element.type == 'QUALITY' ||
    elementChange.element.type == 'PART'
    ? true
    : false;
}
